export default "__VITE_ASSET__B4Fe0GlS__"